const ORDERS_MAP = {
  pageTitle: 'Mapa de pedidos',
  title: 'Exibição dos pedidos:',
  badge: 'Em separação',
  tooltip: {
    icon: {
      alt: 'Ícone de informações',
    },
    label: 'Dica:',
    body: 'Aqui estão seus pedidos aceitos e que ainda não foram inseridos no app do entregador.',
    tip: 'Agrupe os pedidos mais próximos.',
  },
  numberAbbreviation: 'Nº',
  welcome: {
    message: 'Bem vindo ao mapa dos pedidos em separação.',
    link: 'Veja como funciona',
  },
  detailsButton: 'Ver detalhes',
  caption: {
    green: '0 a 4 min',
    yellow: '5 a 7 min',
    red: '8 min ou mais',
    generic: {
      green: 'Dentro do tempo de separação',
      yellow: 'É melhor separar agora',
      red: 'O tempo está estourando',
    },
  },
  modal: {
    title: 'MAIS DETALHES SOBRE O MAPA DE PEDIDOS',
    mapDetails: {
      subtitle: 'Mapa de Pedidos em Separação',
      text: [
        'Pedidos que foram aceitos e que ainda não foram para o app do entregador nas últimas 2 horas',
        'Confira os pedidos que foram aceitos e que ainda não foram para o app do entregador nas últimas 2 horas',
        'Aproveite para fazer uma melhor roteirização dos pedidos',
      ],
    },
    orderDetails: {
      subtitle: 'Detalhes do pedido',
      text: 'Clique em um pin e veja o pedido detalhado',
    },
    markersColors: {
      subtitle: 'Cor dos pins',
      text: 'Cada cor do pin corresponde a quanto tempo um pedido está em separação',
    },
    closeButton: 'Fechar',
    customer: 'Cliente',
    neighbourhood: 'Bairro',
  },
  filters: {
    title: 'Visualizar os pedidos:',
    placeholder: 'Tipo de pedido',
    receive: 'Comuns',
    scheduled: 'Programados - agora',
    turbo: 'Turbo',
  },
  segment: {
    macroJourney: 'order',
    microJourney: 'map',
    categories: {
      RECEIVE: 'common',
      SCHEDULED: 'scheduled',
      TURBO: 'turbo',
    },
    checkbox: 'checkbox',
    pin: 'pin',
    modalName: 'Pin details',
    link: 'link',
  },
}

export default ORDERS_MAP
